import classNames from 'classnames';

import { SimpleTabsProps } from '../tabs.type';

export const SimpleTabs = ({ tabs, onChange, activeTab }: SimpleTabsProps) => {
  return tabs.map((tab) => (
    <button
      key={tab.name}
      type='button'
      className={classNames('text-subtitle-m whitespace-nowrap', {
        'text-tertiary hover:text-primary': tab.id !== activeTab,
        'text-primary': tab.id === activeTab,
      })}
      onClick={() => onChange(tab.id)}>
      {tab.name}
    </button>
  ));
};
